<div class="hero-container">
  <!-- Zdjęcia aktorów -->
  <div class="actors-container">
    <img src="./assets/img/actor1.png" alt="Aktor 1" class="actor-img" />
    <img src="./assets/img/actor2.png" alt="Aktor 2" class="actor-img" />
    <img src="./assets/img/actor3.png" alt="Aktor 3" class="actor-img" />
    <img src="./assets/img/actor4.png" alt="Aktor 4" class="actor-img" />
  </div>

  <!-- Tekst hero -->
  <div class="hero-text">
    <h1>
      <span class="line-1">UMIEMY ROBIĆ</span>
      <span class="line-2">KOMEDIĘ<span class="exclamation-mark">!</span></span>
    </h1>
  </div>

  <!-- Przyciski nawigacyjne -->
  <div class="buttons-container">
    <button mat-button class="btn-o-nas" routerLink="/o-nas">O nas</button>
    <a href="https://evently.pl/profile/guarana-impro">
      <button mat-button class="btn-repertuar">Repertuar</button>
    </a>
    <!-- <button mat-button class="btn-repertuar" routerLink="/repertuar">
      Repertuar
    </button> -->
  </div>
</div>

<app-about [showFull]="false"></app-about>
